import React from "react";
import { IPuzzleV1 } from "../dataLayer/v1/interfaces/classes/IPuzzleV1";
import { PointerStateManager, PointerStateManagerContext } from "./pointerStateManager";

export type PuzzlePointerStateProviderProps = {
  puzzle: IPuzzleV1;
  children: React.ReactNode;
};

export function PuzzlePointerStateProvider(props: PuzzlePointerStateProviderProps) {
  const pointerStateManager = React.useMemo(
    () => new PointerStateManager(props.puzzle),
    [props.puzzle],
  );

  return (
    <PointerStateManagerContext.Provider value={pointerStateManager}>
      {props.children}
    </PointerStateManagerContext.Provider>
  );
}
